import React from 'react';

const Projects: React.FC = () => {
  const projects = [
    {
      title: 'Real-Time Chat Application',
      description: 'A web-based chat platform that enables users to send and receive messages in real-time. Features include live message updates, user authentication, and responsive UI.',
      tech: 'React, Node.js, Socket.io, Express, MongoDB'
    },
    {
      title: 'Employee Management System',
      description: 'A full-stack application for managing employee records, departments, and performance data. Includes CRUD operations, admin dashboards, and secure login system.',
      tech: 'TypeScript, React, REST API, PostgreSQL, Node.js'
    },
    {
      title: 'AI-Powered Resume Ranker',
      description: 'A tool that uses natural language processing to evaluate and rank resumes based on job descriptions. Helps HR teams shortlist candidates efficiently.',
      tech: 'Python, Flask, Scikit-learn, React, OpenAI API'
    }
  ];

  return (
    <section className="projects section">
      <div className="container">
        <h2>Featured Projects</h2>
        <div className="project-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <p><strong>Tech Stack:</strong> {project.tech}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;